<template>
    <div>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="120" />
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">{{$t('global.common.save',{defaultValue:'保存'})}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.operate_cancel',{defaultValue:'取消'})}}</vButton>
			</template>
		</compWrapper>

        <compWrapper :title="$t('erp.b2border.ship_address',{defaultValue:'发运地址信息'})" theme="primary">
            <compShipment :shipdata="shipFormdata" :alltype="type" ref="refshipment" :allcountries="countries"></compShipment>
		</compWrapper>

        <compWrapper :title="$t('erp.b2border.invoice_address',{defaultValue:'发票地址信息'})" theme="primary">
            <compInvoice :invoicedata="invoiceFormdata" :alltype="type" ref="refinvoice" :allcountries="countries"></compInvoice>
		</compWrapper>

        <compWrapper :title="$t('erp.b2border.notes_information',{defaultValue:'备注信息'})" theme="primary">
			<compFormQuery v-if="type=='query'" :formdata="getNotes" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix" ref="notesform" :formdata="getNotes" v-model="formData" :labelWidth="120" />
		</compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import compShipment from './shipmenttable'
import compInvoice from './invoicetable'
import { HttpGetCustomerOne,HttpSaveCustomerOne } from "@/service/manage/manage";
import { HttpGetContry } from '@/service/boss/dictionary'

import { mapState,mapGetters,mapMutations } from "vuex";
export default {
    props:['activeids','querytype'],
    components: {
		// compWrapper: () => import("@components/templates/wrapper"),
		// compFormQuery: () => import("@components/templates/formquery"),
        // compFormEdit: () => import("@components/templates/formedit"),
        compShipment,
        compInvoice
        // compLog: () => import("./log"),
	},
    data(){
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            formData:{
                type:'ORGANIZATION',
                channelsArr:"",
            },
            shipFormdata:{},
            invoiceFormdata:{},
            countries:[],
            loading:false,
        }
    },
    created(){
        this.update()
        this.getContry()
    },
    computed:{
        ...mapGetters('diction',['getNewAccountList','getAllSalesList']),
        getBase(){
            return [
                {
					label: this.$t('erp.b2border.customer_type',{defaultValue:'客户类型'}),
                    key: "type",
                    tag:'vSelect',
                    options:[
                        {value:'ORGANIZATION',label:'Organization'},
                        {value:'PERSON',label:'Person'}
                    ],
                    query:this.type != 'add'
                },
                {
					label: this.$t('erp.b2c.customers_email',{defaultValue:'邮箱'}),
                    key: "email",
                    query:this.type != 'add'
                },
                {
					label: this.$t('erp.b2border.customerName',{defaultValue:'客户姓名'}),
					key: "customerName",
                },
                {
					label: this.$t('global.common.channel',{defaultValue:'渠道'}),
                    key: "channelsArr",
                    required:false,
					tag: 'vSelect',
					options: this.getNewAccountList,
					props: {
                        filterable: true,
                        clearable:true,
                        multiple:true,
					}
                },
                {
					label: this.$t('erp.b2border.salesman',{defaultValue:'销售员名称'}),
                    key: "salespersonId",
                    tag:'vSelect',
                    options:this.getAllSalesList,
                    props: {
						filterable: true,
					}
                },
                {
					label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    key: "paymentTerm",
                    tag:'vSelect',
                    required:false,
                    options:[
                        {value:'30NET',label:'30NET'},
                        {value:'60NET',label:'60NET'},
                        {value:'90NET',label:'90NET'},
                    ],
				},
				{
					label: this.$t('erp.b2border.invoice_sending',{defaultValue:'发票发送方式'}),
                    key: "invoiceSendType",
                    tag:'vSelect',
                    required:false,
                    options:[
                        {value:'Email',label:'Email'},
                        {value:'Fax',label:'Fax'}
                    ],
				},
            ]
        },
        getNotes(){
            return [
                {
					label: this.$t('global.common.notes',{defaultValue:'备注'}),
                    key: "remark",
                    tag:'vTextarea',
                    required:false,
				},
            ]
        },
        
    },
    methods:{
        ...mapMutations('diction', ['clearStore']),
        update(){
            if(this.type == 'add') return
            if(this.activeids){
                this.id = this.activeids
                this.type = this.querytype
            }else{
                this.id = this.id
                this.type = this.type
            }
            HttpGetCustomerOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data
                this.shipFormdata = res.data.address
                this.invoiceFormdata = res.data.address
                let arr = res.data.channels.split(",") || ""
                if(arr[0]!=""){
                    this.formData.channelsArr = arr
                }else{
                    this.formData.channelsArr = ''
                }
                // console.log(this.formData.channelsArr,'渠道')
            },err=>{
               this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        getContry(){
            if(this.type == 'query') return
            HttpGetContry({
                "search[EQ_depth]":2
            }).then(res=>{
                this.countries = res.data
            },err=>{

            })
        },
        async submit(){
            let bool1 = await this.$refs.baseform.validate()
            if (!bool1) return
            
            let refshipmentdata = this.$refs.refshipment
            let refinvoicedata = this.$refs.refinvoice
            // console.log(this.formData)
            // console.log(refshipmentdata)
            // console.log(refinvoicedata)
            let shipflag = false; let invoiceflag = false;
            // 判断各个数组内容是都还有默认地址
            if(refshipmentdata.shipmentformList.length>0){
                refshipmentdata.shipmentformList.map(item=>{
                    if(item.isDefault == 'Y'){
                        shipflag = true
                    }
                })
                if(shipflag == false){
                    refshipmentdata.shipmentformList[0].isDefault = 'Y'
                }
            }

            if(refinvoicedata.invoiceformList.length>0){
                refinvoicedata.invoiceformList.map(item=>{
                    if(item.isDefault == 'Y'){
                        invoiceflag = true
                    }
                })
                if(invoiceflag == false){
                    refinvoicedata.invoiceformList[0].isDefault = 'Y'
                }
            }

            let arr = [...refshipmentdata.shipmentformList,...refinvoicedata.invoiceformList]
            this.formData.address = arr
            this.formData.channels = this.formData.channelsArr.join(",")
            // console.log(this.formData)
            this.loading=true;
            HttpSaveCustomerOne({
                orgId:global.SYSID,
                ...this.formData,
            }).then(res=>{
                this.loading=false;
                this.clearStore('allCustomerList');
                this.$VMessage.success(res.message)
                this.cancel()
            },err=>{
                this.loading=false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$router.push({
                name: 'customermanage',
            });
        }
    },
}
</script>